import { useNavigate } from "react-router-dom";
import { useEnableReveal } from "@/lib/useReveal";
import { Nav } from "@/components/ui/Nav";
import { Footer } from "@/components/ui/Footer";
import { Metodo } from "@/components/home/Metodo";
import { Diagnostico } from "@/components/home/Diagnostico";

export default function MetodoPage() {
  useEnableReveal();
  const navigate = useNavigate();
  const goFunnel = () => navigate("/agendar/contato");
  const goHome = () => navigate("/");

  return (
    <>
      <Nav onCTA={goFunnel} onHome={goHome} />
      <main className="page-enter info-page">
        <Metodo />
        <Diagnostico onCTA={goFunnel} />
      </main>
      <Footer onCTA={goFunnel} onHome={goHome} />
    </>
  );
}
